import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcHighPriority, FcList } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuFinancePage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Tagihan",
      image: false,
    });
    setAppBar({
      title: "Tagihan",
      show: true,
      leading: "back",
    });
  }, [setHeader]);
  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-0 menu">
      <div className="tw-px-0 card-body card-body-grid">
        <div className="tw-mx-2 tw-pb-2 card-grid">
          <div
            onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
            <div className="card-name">Bulanan</div>
          </div>
        </div>

        <div className="tw-mx-2 tw-pb-2 card-grid">
          <div
            onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
            <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
            <div className="card-name">Non Bulanan</div>
          </div>
        </div>

        {/* <div className="tw-mx-2 tw-pb-2 card-grid">
          <div
            onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
            className="tw-m-0"
          >
            <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
            <FcList className="card-icon" />
            <div className="card-name">Rekening Koran</div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
